import { FunctionComponent, useContext } from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { UserContext, UserNeedsAuthentication } from "components/user";
import { PageLayout, Wrapper } from "components/layout";
import { ProjectHeader } from "components/projectHeader";
import { ProjectErrorsProvider } from "hooks/useProjectErrors";
import { Project } from "./Project";
import { CollectionForm } from "./CollectionForm";
import { Errors } from "./Errors";

/**
 * Layout shared by every page nested under /:projectId. Rendering ProjectHeader
 * here (rather than in each individual page) means it stays mounted while
 * navigating between the project overview, the form editor, and the errors
 * page — only the nested route below it swaps out.
 */
const ProjectLayout: FunctionComponent = () => {
    const { projectId } = useParams<{ projectId: string }>();
    const { path } = useRouteMatch();

    return (
        <ProjectErrorsProvider projectId={projectId}>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <ProjectHeader projectId={projectId} />
                <Switch>
                    <Route exact path={`${path}/form`} render={() => <CollectionForm key={Date.now()} />} />
                    <Route exact path={`${path}/errors`} render={() => <Errors key={Date.now()} />} />
                    <Route exact path={path} render={() => <Project key={Date.now()} />} />
                </Switch>
            </div>
        </ProjectErrorsProvider>
    );
};

const ProjectLayoutPage: FunctionComponent = () => {
    const { authenticated } = useContext(UserContext);

    return (
        <PageLayout header footer>
            <Wrapper>
                {authenticated ? <ProjectLayout /> : <UserNeedsAuthentication />}
            </Wrapper>
        </PageLayout>
    );
};

export default ProjectLayoutPage;
